module.exports = __webpack_public_path__ + "static/media/buter-pocket.824b9f8c.jpg";